import styles from './TotalInfoCard.module.css';

function TotalInfoCard({
  icon,
  label,
  percentage,
  count,
  colorVar,
  onClick = null,
}) {
  const cardStyle = {
    '--card-color': `var(${colorVar})`,
  };
  return (
    <div className={styles.TotalInfoCard} style={cardStyle} onClick={onClick}>
      <div className={styles.IconContainer}>{icon}</div>
      <div className={styles.LeftSection}>
        <p className={styles.Label}>{label}</p>
        <p
          className={`${styles.PercentageLabel} ${
            percentage > 0 && styles.PercentagePositive
          } ${percentage < 0 && styles.PercentageNegative}`}
        >
          {percentage > 0 && '+'}
          {percentage}%
        </p>
      </div>
      <div className={styles.RightSection}>{count}</div>
    </div>
  );
}

export default TotalInfoCard;
